import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  cs: {
    common: {
      slovakBanner: 'Slovenská verze celého webu již brzy.',
      navbarHome: 'Domů',
      navbarAbout: 'O mně',
      navbarProjects: 'Projekty',
      navbarSkills: 'Dovednosti',
      navbarFriends: 'Přátelé',
      navbarContact: 'Kontakt'
    },
    home: {
      heroSubtitle: 'Můj život není snadný. Mám zdravotní potíže, které mě každý den zkouší. Ale i tak hledám důvod vstát, tvořit a ukázat, že to jde i s pádem v zádech.',
      projectsButton: 'Prozkoumat Projekty',
      contactButton: 'Kontakt',
      upcomingTitle: 'Novinky už brzy!',
      upcomingDescription: 'Připravuji několik skvělých funkcí a projektů, které tento web posunou na další úroveň.',
      upcomingButton: 'Co se chystá?',
      techTitle: 'Technologie, Které Ovládám',
      techDescription: 'Používám nejmodernější technologie pro vytváření škálovatelných a výkonných aplikací',
      skillsButton: 'Zobrazit Všechny Dovednosti',
      ctaTitle: 'Připraven realizovat váš projekt?',
      ctaDescription: 'Mám zkušenosti s různorodými projekty od startupů po enterprise řešení. Můžeme vytvořit něco výjimečného.',
      ctaButton: 'Napište Mi'
    },
    skills: {
      heroTitle: 'Technické Dovednosti',
      heroSubtitle: 'Komplexní přehled mých schopností napříč různými technologiemi a oblastmi vývoje. Neustále se učím a rozšiřuji své znalosti.',
      allLabel: 'Všechny',
      gridLabel: 'Mřížka',
      listLabel: 'Seznam',
      categories: {
        'Programovací Jazyky': 'Programovací Jazyky',
        'Webové Technologie': 'Webové Technologie',
        'Knihovny & Frameworky': 'Knihovny & Frameworky',
        'Databáze': 'Databáze',
        'Nástroje & Platformy': 'Nástroje & Platformy'
      },
      descriptions: {
        'JavaScript': 'Moderní ES6+, asynchronní programování, DOM manipulace a event handling. Expert a více dovedností',
        'TypeScript': 'Typové systémy, rozhraní, generické typy a type safety',
        'Python': 'Základy programování, skripty a automatizace',
        'Java Minecraft Plugin': 'Učím se',
        'HTML5': 'Sémantické značky, formuláře, multimédia a webová přístupnost',
        'CSS3': 'Flexbox, Grid, animace, responzivní design a moderní layouty',
        'React.js': 'Komponenty, hooks, state management a moderní React patterns',
        'Node.js': 'Server-side JavaScript, npm ekosystém a backend vývoj',
        'Express.js': 'Webový framework pro Node.js, routování a middleware. Expert a více dovedností',
        'Next.js': 'React framework s SSR, SSG a optimalizací výkonu',
        'MySQL': 'Relační databáze, SQL dotazy a návrh schémat',
        'Git': 'Verzovací systém, základní příkazy a repozitáře',
        'VS Code': 'Oblíbený editor, rozšíření, debugování a produktivita'
      },
      ctaTitle: 'Připraven realizovat váš projekt?',
      ctaDescription: 'Mám zkušenosti s různorodými projekty od startupů po enterprise řešení. Můžeme vytvořit něco výjimečného.',
      ctaContact: 'Napište Mi',
      ctaViewProjects: 'Prohlédnout Projekty'
    },

    friends: {
      heroTitle: 'Moji přátelé',
      intro: 'Přátelství pro mě znamená víc než jen společný čas, jsou to lidé, kteří mě podporují, inspirují a přinášejí do mého života radost i porozumění. Každý z mých přátel má svůj jedinečný příběh a společně tvoří síť podpory, na kterou se mohu spolehnout.',
      friendSince: '📅 Přátelé od',
      communityTitle: 'Spolu tvoříme víc',
      communityDescription: 'Společně tvoří moji malou komunitu, kde panuje důvěra, porozumění a společná radost. Díky nim se necítím sám a každý den mám pocit, že patřím někam, kde mohu být autentický a být s lidmi, kteří mě podporují.',
      discordDescription: 'Discord zatím nemáme veřejně dostupný. Připravujeme komunitní server, brzy bude!',
      discordSoon: '💬 Discord brzy',
      tags: {
        support: 'Opora',
        loyalty: 'Věrnost',
        humor: 'Humor',
        energy: 'Energie',
        inspiration: 'Inspirace',
        growth: 'Růst',
        physicalSupport: 'Fyzická podpora',
        mentalSupport: 'Psychická podpora'
      },
      friends: {
        herixon: {
          description: 'HeriXon075 je můj dlouhodobý kamarád, se kterým se známe přes Discord od roku 2021. Je oporou, na kterou se vždy mohu spolehnout. Zná mé slabosti i radosti a nikdy mě nesoudí. Společně jsme prožili spoustu zážitků, ať už při hrách, online chatování, nebo v těžších chvílích, kdy bylo důležité cítit podporu a porozumění.'
        },
        myster: {
          description: 'MysterTrolles do mého života přináší energii a humor. Dokáže zvednout náladu i v nejtěžších dnech a umí proměnit obyčejné chvíle ve zábavu. Přesto je také někým, kdo ví, kdy být vážný a oporou. Jeho smysl pro humor a pozitivní přístup mě motivuje a dodává mi energii do každodenního života.'
        },
        gojo: {
          description: 'gojosatoru11222 mě inspiruje a motivuje k osobnímu růstu. Je to přítel, se kterým mohu otevřeně sdílet své myšlenky a názory, a zároveň dostávám nový pohled na situace, které mě posouvají dál. Díky jeho podpoře se cítím silnější a více propojený s okolním světem.'
        }
      }
    },





    contact: {
      scamWarning: 'Pokud mě chcete kontaktovat, napište mi jako 𝒜𝐿𝒫𝐻𝒜𝐿𝒰𝒦. Pokud si mě někdo přidá do přátel bez zprávy, budu to považovat za scam a automaticky ho zablokuji.',

      heroTitle: 'Kontakt',
      heroEyebrow: 'Spojme se',
      discordSectionTitle: 'Komunita na Discordu',
      formSectionTitle: 'Napište mi',
      formSectionSubtitle: 'Vyplňte formulář — otevře se váš e-mailový klient se zprávou připravenou k odeslání.',
      mailtoMissingConfig:
        'Pro odeslání e-mailu nastavte proměnnou REACT_APP_CONTACT_EMAIL v souboru .env (viz dokumentace Create React App).',
      discordDescription: 'Discord zatím nemáme veřejně dostupný. Připravujeme komunitní server, brzy bude!',
      discordSoon: '💬 Discord brzy',
      faqTitle: 'Často kladené otázky',
      form: {
        badge: 'Kontaktní formulář',
        nameLabel: 'Jméno a příjmení *',
        namePlaceholder: 'Jan Novák',
        emailLabel: 'E-mail *',
        emailPlaceholder: 'jan.novak@example.com',
        subjectLabel: 'Předmět *',
        subjectPlaceholder: 'Nový projekt — e‑shop',
        budgetLabel: 'Rozpočet (volitelné)',
        budgetPlaceholder: 'Vyberte rozpočet',
        timelineLabel: 'Časový rámec (volitelné)',
        timelinePlaceholder: 'Vyberte časový rámec',
        messageLabel: 'Zpráva *',
        messagePlaceholder: 'Popište mi váš projekt, cíle a požadavky…',
        contactMethodLabel: 'Preferovaný způsob kontaktu',
        submit: 'Odeslat zprávu',
        sending: 'Odesílání…',
        charCount: '{{count}}/500 znaků',
        budget: {
          '': 'Vyberte rozpočet',
          'under-5k': 'Do 50 000 Kč',
          '5k-10k': '50 000 – 100 000 Kč',
          '10k-25k': '100 000 – 250 000 Kč',
          '25k-50k': '250 000 – 500 000 Kč',
          'over-50k': 'Nad 500 000 Kč',
          discuss: 'Chci prodiskutovat',
        },
        timeline: {
          '': 'Vyberte časový rámec',
          urgent: 'Urgentní (do 1 týdne)',
          '1-month': 'Do 1 měsíce',
          '2-3-months': '2–3 měsíce',
          '3-6-months': '3–6 měsíců',
          '6-plus-months': '6+ měsíců',
          flexible: 'Flexibilní',
        },
        method: {
          email: 'E-mail',
          phone: 'Telefon',
          video: 'Video hovor',
        },
        errors: {
          name: 'Jméno je povinné',
          email: 'E-mail je povinný',
          emailInvalid: 'Neplatný formát e-mailu',
          subject: 'Předmět je povinný',
          message: 'Zpráva musí mít alespoň 10 znaků',
        },
      },
      faq: {
        q1: { question: 'Jak rychle odpovídáš na zprávy?', answer: 'Záleží na vytížení, ale většinou odpovím do 24 hodin. Na technické nebo projektové dotazy si radši vezmu trochu víc času, abych odpověděl pořádně a ne jen formálně. Kvalita odpovědi je pro mě důležitější než rychlost.' },
        q2: { question: 'V jakých technologiích pracuješ?', answer: 'Používám hlavně React, Node.js a TypeScript, to je kombinace, která mi umožňuje tvořit rychlé a stabilní aplikace. Nehoním se za módními frameworky, spíš hledám technologie, které mají dlouhodobý smysl.' },
        q3: { question: 'Proč ses začal věnovat programování?', answer: 'Chtěl jsem mít možnost tvořit věci, které opravdu fungují. Programování mi dalo prostor propojit logiku s kreativitou, přemýšlet, navrhovat a řešit problémy. Je to způsob, jak přetvořit nápad v něco reálného, a zároveň nikdy nekončící proces učení.' },
        q4: { question: 'Co tě na tvé práci baví nejvíc?', answer: 'Ten moment, kdy z nápadu vznikne něco, co žije vlastním životem. Když aplikace, kterou postavíš, začne lidem reálně pomáhat. Je to směs frustrace, trpělivosti a radosti, ale právě v tom je kouzlo vývoje.' },
        q5: { question: 'Co pro tebe byla největší profesní výzva?', answer: 'Vytvořit systém, který nesmí selhat. Každá chyba mohla mít důsledky pro skutečné lidi, takže jsem se musel naučit přemýšlet o kódu jinak, s větším respektem k tomu, jaký dopad má moje práce. Od té doby beru každý projekt vážně: ne jako úkol, ale jako zodpovědnost.' },
        q6: { question: 'Jak přistupuješ k novým projektům?', answer: 'Vždycky se ptám proč. Nechci jen psát kód, chci pochopit, jaký problém se řeší a komu to má pomoci. Když znám smysl, dokážu navrhnout řešení, které má hlavu a patu. Snažím se vyvážit funkčnost, udržitelnost a rozumné náklady.' },
        q7: { question: 'Proč projekty stojí peníze?', answer: 'Protože vývoj není jen o napsání pár řádků kódu. Každý projekt znamená hodiny analýzy, návrhu, testování, ladění a odpovědnosti. Za výsledkem není jen samotná práce, ale i zkušenosti, které umožňují udělat věci správně, bezpečně, stabilně a dlouhodobě. Platíš tedy nejen za čas, ale hlavně za řešení problému, které funguje a vydrží. A to má hodnotu, protože ušetří čas, chyby i stres v budoucnu.' },
        q8: { question: 'Co považuješ za nejdůležitější v programování?', answer: 'Upřímnost k sobě i ke kódu. Pokud něco nefunguje, přiznat to a najít řešení. Nepřekombinovat věci, když to není nutné. A přemýšlet nad tím, kdo ten software používá a proč. Kód může být dokonalý technicky, ale pokud lidem nepomáhá, ztrácí smysl.' }
      }
    },



    projects: {
      heroTitle: 'Projekty',
      projectsContent: `Již brzy zde naleznete mé nejnovější, nejpropracovanější a nejinovativnější projekty, na kterých momentálně intenzivně pracuji. 🌟 Každý z nich vzniká s důrazem na kvalitu, originalitu a praktičnost, aby byl přínosem nejen pro mě, ale i pro vás, ať už jste vývojář, tvůrce obsahu, nebo prostě jen někdo, kdo má rád moderní technologie a nápady, které dávají smysl. <br /><br />

          Tyto projekty zde nebudou pouze na ukázku. Budete si je moci stáhnout k volnému použití, abyste s nimi mohli dále pracovat podle svých představ. Chci, aby každý měl možnost využít je naplno, upravit je, rozšířit nebo je začlenit do vlastních projektů. Moje filozofie je jednoduchá: když něco tvořím, chci, aby to mohlo pomoci i ostatním. 💡 <br /><br />

          Každý projekt bude pečlivě popsán, s uvedením všech důležitých detailů, návodů a možností využití. Tím vám chci usnadnit práci a zajistit, že přesně pochopíte, jak s projektem naložit a co všechno z něj můžete vytěžit. 📘 <br /><br />

          A pokud byste si přáli, mohu vám navíc projekt nastavit přímo na hosting, abyste se nemuseli starat o žádné technické záležitosti. Celý proces nasazení, konfigurace i otestování provedu za vás, vy tak dostanete hotové řešení, které bude okamžitě připravené k použití. 💻 <br /><br />

          ✨ Už brzy se tedy můžete těšit na místo plné nápadů, inspirace a technických řešení, která vám otevřou nové možnosti. Připravte se, tohle bude teprve začátek! 🚀`,
    },
    ads: {
      heroTitle: '📰 Reklamy – již brzy na mém webu!',
      heroSubtitle:
        'Pracuji na tom, aby bylo možné na webu jednoduše a přehledně přidávat, upravovat a spravovat své reklamy, ať už jde o projekty, služby, servery nebo cokoliv zajímavého, co chcete ostatním ukázat.',
      introP1:
        'Pracuji na tom, aby bylo možné na webu jednoduše a přehledně přidávat, upravovat a spravovat své reklamy, ať už jde o projekty, služby, servery nebo cokoliv zajímavého, co chcete ostatním ukázat.',
      introP2:
        'Mým cílem je vytvořit systém, který nabídne nejen prostor pro zviditelnění, ale také pohodlné a bezpečné prostředí pro uživatele.',
      introP3:
        'Momentálně se soustředím hlavně na backend, tedy na část webu, která zajišťuje, aby vše fungovalo správně v zákulisí.',
      backendTitle: 'Co je backend?',
      backendLead: 'Zjednodušeně řečeno, backend je mozek každého webu.',
      backendP1:
        'Zatímco frontend je to, co vidíte – tlačítka, texty, obrázky a stránky –, backend pracuje tiše na pozadí a stará se o všechno, co se děje mezi uživatelem a serverem.',
      backendP2: 'Díky backendu bude možné',
      backendList: [
        { icon: '🧾', text: 'Vytvářet a ukládat vaše reklamy' },
        { icon: '🔐', text: 'Registrovat se a přihlašovat přes vlastní účet' },
        { icon: '👤', text: 'Spravovat svůj profil a přehled reklam' },
        { icon: '💬', text: 'Komunikovat s ostatními uživateli' },
        { icon: '📊', text: 'Zobrazovat statistiky návštěvnosti a zobrazení' },
      ],
      backendP3:
        'Všechny tyto funkce vyžadují bezpečné propojení mezi webem a databází, což je přesně to, na čem teď pracuji.',
      backendP4:
        'Až bude tato část dokončená, spustím plnohodnotný systém s možností registrace, přihlášení a přidávání reklam.',
      nextTitle: 'Co vás čeká dál',
      nextP1:
        'Jakmile bude backend plně hotový, stránka s reklamami se otevře všem registrovaným uživatelům.',
      nextP2:
        'Každý bude mít svůj účet, kde uvidí své reklamy, může je upravovat, mazat a sledovat jejich úspěšnost.',
      nextP3:
        'Chci, aby systém byl jednoduchý, rychlý a přehledný i pro ty, kdo s weby nemají žádné zkušenosti.',
      nextP4:
        'Cílem je vytvořit férové prostředí, kde každý dostane možnost zviditelnit svůj projekt nebo nabídku bez složitostí a zbytečných poplatků.',
      whenTitle: 'Kdy to bude hotové?',
      whenP1:
        'Pracuji postupně, testuji přihlašování, profily i bezpečnostní funkce, aby vše běželo hladce a bez chyb.',
      whenP2: 'Nechci nic uspěchat, protože kvalitní základ je důležitější než rychlé spuštění.',
      ctaTitle: 'Zůstaňte naladěni!',
      ctaText:
        'Brzy přidám více informací a spustím beta verzi. Pokud máte nápady nebo otázky, neváhejte mě kontaktovat přes kontaktní stránku.',
      contactCta: 'Přejít na kontakt',
    },
    comingSoon: {
        alertTitle: 'Upozornění',
        alertText: 'Tento seznam má pouze informativní charakter. Termíny vydání nejsou garantovány a jednotlivé položky se mohou změnit nebo nemusí být zahrnuty ve finální verzi.',
        preparing: 'Právě se připravuje',
        mainHeading: 'Věci, které vyjdou brzy 🚀',
        introText: 'Pracuji na řadě nových funkcí, projektů a vychytávek, které brzy rozšíří tento web. Sledujte tuto stránku a nenechte si nic ujít!',
        backButton: 'Zpět na úvodní stránku',
        skComingSoonBanner: 'Slovenská verze celého webu již brzy.',
      sections: [
        {
          icon: '🧩',
          title: 'Základní funkce backendu',
          items: [
            'Přihlášení a registrace (e-mail, heslo, 2FA, Discord / Google login)',
            'Bezpečné ukládání hesel pomocí bcrypt a hashování',
            'Resetování hesla a ověření účtu přes e-mail',
            'Ověření účtu (verifikační e-mail)',
          ]
        },
        {
          icon: '👤',
          title: 'Správa uživatelů',
          items: [
            'Editace profilu (jméno, avatar, bio), nastavení soukromí',
            'Ukládání statistik, bodů, úrovní či rolí',
            'Banování nebo pozastavení účtu',
          ]
        },
        {
          icon: '💬',
          title: 'Interakce a obsah',
          items: [
            'Reklamní systém (bannery, statistiky zobrazení a kliknutí)',
            'Komentáře a příspěvky, moderace a hodnocení',
          ]
        },
        {
          icon: '📂',
          title: 'Databázové věci',
          items: [
            'Články, novinky, blogy, příspěvky',
            'Přehled registrovaných uživatelů a jejich aktivit',
            'Statistiky návštěvnosti, ukládání obrázků',
          ]
        },
        {
          icon: '⚙️',
          title: 'Admin & správa webu',
          items: [
            'Přehled uživatelů, aktivit a obsahu',
            'Správa novinek, bannerů, textů a nastavení',
            'Statistiky (návštěvy, registrace, komentáře)',
          ]
        },
        {
          icon: '🔒',
          title: 'Bezpečnost',
          items: [
            'Anti-spam a anti-bot ochrana (reCAPTCHA, rate limit)',
            'Ukládání logů pro detekci chyb a útoků',
            'HTTPS, zabezpečení JWT, CORS',
          ]
        },
        {
          icon: '🌐',
          title: 'Další doplňky',
          items: [
            'API pro Discord',
            'Notifikace přes e-maily i interní oznámení',
            'Podpora / kontaktní formulář a ticket systém',
          ]
        }
      ]
      },
      footer: {
      socialLinksTitle: 'Sociální sítě',
      soonPagesTitle: 'Brzy dostupné stránky',
      adsSoon: 'Reklama (již brzy)',
      projectsSoon: 'Projekty (již brzy)',
      faqLink: 'FAQ',
      madeWith: 'Vytvořeno s ❤️ a kódem.',
      copyright: '© {{year}} Alphaluk. Všechna práva vyhrazena.'
    },
    about: {
      heroTitle: 'Můj Příběh',
      heroSubtitle: 'Příběh člověka, který navzdory bolesti tvoří, baví a inspiruje.',
      bookSectionTitle: 'Objevte svět Tourettova syndromu',
      bookSectionSubtitle: 'Doporučení na knihu, která otevírá dveře k pochopení',
      bookBadge: 'Doporučená četba',
      bookTitle: 'Žijeme s Tourettovým syndromem',
      bookLead: 'Pokud chcete vědět více o Tourettově syndromu, můžete si přečíst knihu <strong>Žijeme s Tourettovým syndromem</strong>.',
      bookDescription: 'Nejedná se o žádnou placenou propagaci, prostě se mi zdá, že je to velmi užitečný zdroj pro všechny, kdo chtějí pochopit, co Tourettův syndrom obnáší, jak se s ním žije a jak mohou lidem s tímto syndromem pomoci nebo je lépe pochopit.',
      cardTitle: 'Kniha plná',
      cardSubtitle: 'poznání & pochopení',
      buttonText: 'Zobrazit knihu',
      personalNoteTitle: 'Osobní Poznámka',
      personalNoteP1: 'Netvořím proto, že bych měl nějakou povinnost. Tvorba je pro mě spíš únik, místo, kde můžu dýchat. Když pracuju na videích nebo na čemkoli, co mě baví, trochu se mi uleví. Je to způsob, jak ze sebe dostat to, co nosím v hlavě, a někdy tím třeba někomu zvednout náladu nebo dodat sílu.',
      personalNoteP2: 'Moje zdravotní věci jsou prostě realita, se kterou žiju. Každý den si skládám tak, aby to pro mě bylo zvládnutelné. Někdy to jde hladce, jindy je to těžší, ale beru to tak, že se s tím prostě učím žít. Nesnažím se být nezničitelnej, jen k sobě upřímnější.',
      personalNoteP3: 'A můj cíl? Být pravdivý. Pobavit, když to jde. A pokud to někomu pomůže necítit se tak sám, tak to pro mě znamená hodně. Každý člověk, který si něco těžkého nosí v sobě a stejně to zvládá, je pro mě hrdina. A jestli můžu připomenout aspoň jednomu člověku, že i ve tmě se dá najít světlo, tak má moje práce smysl.',
      storyContent: `Jmenuju se Lukáš, neboli AlphaLuk. Pro většinu lidí jsem jen jméno z internetu. Věnuju se tvorbě obsahu, videí a projektů. Ale za tím vším je život, který nebyl lehký, a zkušenosti, které mě formovaly víc, než si dokážu přiznat.

**Moje problémy začaly, když mi bylo osm let.** Tiky, závraty, zvláštní stavy, ze kterých jsem se bál. Nikdo to nechápal. Spolužáci se mi smáli, učitelé mi nevěřili a dokonce i ředitelka mě nechala napospas. Nešlo jen o dospělé, i děti mě šikanovaly, posmívaly se mi a odsuzovaly mě za něco, co nemohu ovládat.

**Pamatuju si jeden okamih v tělocviku.** Zatočila se mi hlava tak, že jsem nevěděl, jestli spadnu, nebo co se se mnou děje. Rozbrečel jsem se. A místo pomoci přišlo jen:

„Přestaň si vymýšlet a pokračuj."

**Ten pocit bezmoci je něco, co se ti vryje do paměti navždy.** Malý kluk, který nechápe, proč mu nikdo nevěří, proč svět, který by měl chránit, je proti nemu. Nakonec to vyústilo v přestup uprostřed páté třídy. Nová škola byla jiná. Tam jsem narazil na dvě učitelky, které mi věřily a podporovaly mě. Právě ony mi tehdy dodaly sílu jít dál.

**Moje zdravotní problémy pokračovaly.** Doktoři mi později řekli, že nejspíš mám mírnou formu epilepsie, ale potvrzené to není. A i tak je každý den výzvou. Někdy je den v pohodě, někdy mám pocit, že se svět točí a já jen bojuju o rovnováhu. Ven moc nechodím sám, nikdy nevím, co přijde.

**Tvorba byla vždycky můj únik.** Dřív jsem dělal Minecraft servery, pomáhal v EchoDabingu jako Helper, a dnes jsem tam hlavně Zástupce Majitele, protože můj kámoš MysterTrolles mi věří a já jemu. Už se nepodílím na promu, ale být součástí týmu je pro mě pořád důležité. K tomu mám pár skvělých přátel, kteří stojí při mně, i když to není jednoduché.

**Tvorba mi dává sílu přežít dny, kdy je všechno těžké.** Pomáhá mi vyjádřit strach, bolest a vztek. A pokud díky ní někomu můžu dát naději nebo odvahu, má to pro mě smysl.

**A jestli tohle čte někdo, kdo prochází něčím podobným:**

Nejsi slabý. Nejsi divný. Nejsi sám.

Někdy se ti budou smát, někdy ti neuvěří, někdy tě odsoudí. Ale to neznamená, že tvůj boj není skutečný. Že tvá bolest je méně hodnotná.

**Já jsem AlphaLuk.**

Prošel jsem si věcmi, které mě lámaly (od šikany dětí, učitelů i ředitelky) a přesto stojím. Nepřestal jsem bojovat. A nikdy nepřestanu.

**Pokud to dokázal někdo jako já, dokážeš to i ty.**`
    }
  },
  sk: {
    common: {
      slovakBanner: 'Slovenská verzia celého webu už čoskoro.',
      navbarHome: 'Domov',
      navbarAbout: 'O mne',
      navbarProjects: 'Projekty',
      navbarSkills: 'Zručnosti',
      navbarFriends: 'Priatelia',
      navbarContact: 'Kontakt'
    },

    home: {
      heroSubtitle: 'Môj život nie je ľahký. Mám zdravotné problémy, ktoré ma každý deň skúšajú. Napriek tomu hľadám dôvod vstať, tvoriť a ukázať, že to ide aj s bolesťami v chrbte.',
      projectsButton: 'Preskúmať Projekty',
      contactButton: 'Kontakt',
      upcomingTitle: 'Novinky už čoskoro!',
      upcomingDescription: 'Pripravujem niekoľko skvelých funkcií a projektov, ktoré tento web posunie na ďalšiu úroveň.',
      upcomingButton: 'Čo sa chystá?',
      techTitle: 'Technológie, Ktoré Ovládam',
      techDescription: 'Používam najmodernejšie technológie na vytváranie škálovateľných a výkonných aplikácií',
      skillsButton: 'Zobraziť Všetky Zručnosti',
      ctaTitle: 'Pripravený realizovať váš projekt?',
      ctaDescription: 'Mám skúsenosti s rôznorodými projektmi od startupov po enterprise riešenia. Môžeme vytvoriť niečo výnimočné.',
      ctaButton: 'Napíšte Mi'
    },
    comingSoon: {
      alertTitle: 'Upozornenie',
      alertText: 'Tento zoznam má iba informatívny charakter. Termíny vydania nie sú garantované a jednotlivé položky sa môžu zmeniť alebo nemusia byť zahrnuté vo finálnej verzii.',
      preparing: 'Práve sa pripravuje',
      mainHeading: 'Veci, ktoré vyjdú čoskoro 🚀',
      introText: 'Pracujem na rade nových funkcií, projektov a vychytávok, ktoré čoskoro rozšíria tento web. Sledujte túto stránku a nenechajte si nič ujsť!',
      backButton: 'Späť na úvodnú stránku',
      sections: [
        {
          icon: '🧩',
          title: 'Základné funkcie backendu',
          items: [
            'Prihlásenie a registrácia (e-mail, heslo, 2FA, Discord / Google login)',
            'Bezpečné ukladanie hesiel pomocou bcrypt a hashovania',
            'Resetovanie hesla a overenie účtu cez e-mail',
            'Overenie účtu (verifikačný e-mail)',
          ]
        },
        {
          icon: '👤',
          title: 'Správa používateľov',
          items: [
            'Editácia profilu (meno, avatar, bio), nastavenie súkromia',
            'Ukladanie štatistík, bodov, úrovní či rolí',
            'Banovanie alebo pozastavenie účtu',
          ]
        },
        {
          icon: '💬',
          title: 'Interakcie a obsah',
          items: [
            'Reklamný systém (bannery, štatistiky zobrazení a kliknutí)',
            'Komentáre a príspevky, moderovanie a hodnotenie',
          ]
        },
        {
          icon: '📂',
          title: 'Databázové veci',
          items: [
            'Články, novinky, blogy, príspevky',
            'Prehľad registrovaných používateľov a ich aktivít',
            'Štatistiky návštevnosti, ukladanie obrázkov',
          ]
        },
        {
          icon: '⚙️',
          title: 'Admin & správa webu',
          items: [
            'Prehľad používateľov, aktivít a obsahu',
            'Správa noviniek, bannerov, textov a nastavení',
            'Štatistiky (návštevy, registrácie, komentáre)',
          ]
        },
        {
          icon: '🔒',
          title: 'Bezpečnosť',
          items: [
            'Anti-spam a anti-bot ochrana (reCAPTCHA, rate limit)',
            'Ukladanie logov pre detekciu chýb a útokov',
            'HTTPS, zabezpečenie JWT, CORS',
          ]
        },
        {
          icon: '🌐',
          title: 'Ďalšie doplnky',
          items: [
            'API pre Discord',
            'Notifikácie cez e-maily aj interné oznámenia',
            'Podpora / kontaktný formulár a ticket systém',
          ]
        }
      ]
    },
    skills: {
      heroTitle: 'Technické Zručnosti',
      heroSubtitle: 'Komplexný prehľad mojich schopností naprieč rôznymi technológiami a oblasťami vývoja. Neustále sa učím a rozširujem svoje znalosti.',
      allLabel: 'Všechny',
      gridLabel: 'Mriežka',
      listLabel: 'Zoznam',
      categories: {
        'Programovacie Jazyky': 'Programovacie Jazyky',
        'Programovací Jazyky': 'Programovacie Jazyky',
        'Webové Technológie': 'Webové Technológie',
        'Webové Technologie': 'Webové Technológie',
        'Knižnice & Frameworky': 'Knižnice & Frameworky',
        'Knihovny & Frameworky': 'Knižnice & Frameworky',
        'Databázy': 'Databázy',
        'Databáze': 'Databázy',
        'Nástroje & Platformy': 'Nástroje & Platformy'
      },
      descriptions: {
        'JavaScript': 'Moderný ES6+, asynchrónne programovanie, DOM manipulácia a event handling. Expert a viac zručností',
        'TypeScript': 'Typové systémy, rozhrania, generické typy a type safety',
        'Python': 'Základy programovania, skripty a automatizácia',
        'Java Minecraft Plugin': 'Učím sa',
        'HTML5': 'Sémantické značky, formuláre, multimédiá a webová prístupnosť',
        'CSS3': 'Flexbox, Grid, animácie, responzívny dizajn a moderné layouty',
        'React.js': 'Komponenty, hooks, state management a moderné React patterns',
        'Node.js': 'Server-side JavaScript, npm ekosystém a backend vývoj',
        'Express.js': 'Webový framework pro Node.js, routovanie a middleware. Expert a viac zručností',
        'Next.js': 'React framework s SSR, SSG a optimalizáciou výkonu',
        'MySQL': 'Relačná databáza, SQL dotazy a návrh schém',
        'Git': 'Verzovací systém, základné príkazy a repozitáre',
        'VS Code': 'Obľúbený editor, rozšírenia, debugovanie a produktivita'
      },
      ctaTitle: 'Pripravený realizovať váš projekt?',
      ctaDescription: 'Mám skúsenosti s rôznorodými projektmi od startupov po enterprise riešenia. Môžeme vytvoriť niečo výnimočné.',
      ctaContact: 'Napíšte Mi',
      ctaViewProjects: 'Zobraziť Projekty'
    },

    friends: {
      heroTitle: 'Moji priatelia',
      intro: 'Priateľstvo pre mňa znamená viac než len spoločný čas, sú to ľudia, ktorí ma podporujú, inšpirujú a prinášajú do môjho života radosť aj porozumenie. Každý z mojich priateľov má svoj jedinečný príbeh a spoločne tvoria sieť podpory, na ktorú sa môžem spoľahnúť.',
      friendSince: '📅 Priatelia od',
      communityTitle: 'Spolu tvoríme viac',
      communityDescription: 'Spoločne tvoria moju malú komunitu, kde panuje dôvera, porozumenie a spoločná radosť. Vďaka nim sa necítim sám a každý deň mám pocit, že patrím niekam, kde môžem byť autentický a s ľuďmi, ktorí ma podporujú.',
      discordDescription: 'Discord zatiaľ nemáme verejne dostupný. Pripravujeme komunitný server, čoskoro bude!',
      discordSoon: '💬 Discord čoskoro',
      tags: {
        support: 'Opora',
        loyalty: 'Vernosť',
        humor: 'Humor',
        energy: 'Energia',
        inspiration: 'Inšpirácia',
        growth: 'Rast',
        physicalSupport: 'Fyzická podpora',
        mentalSupport: 'Psychická podpora'
      },
      friends: {
        herixon: {
          description: 'HeriXon075 je môj dlhodobý kamarát, s ktorým sa poznáme cez Discord od roku 2021. Je oporou, na ktorú sa vždy mohu spoľahnúť. Pozná moje slabosti aj radosti a nikdy ma nesúdi. Spoločne sme prežili množstvo zážitkov, či už pri hrách, online chatovaní, alebo v ťažších chvíľach, keď bolo dôležité cítiť podporu a porozumenie.'
        },
        myster: {
          description: 'MysterTrolles do môjho života prináša energiu a humor. Dokáže zdvihnúť náladu aj v najťažších dňoch a vie zmeniť obyčajné chvíle na zábavu. Napriek tomu je tiež niekým, kto vie, kedy byť vážny a oporou. Jeho zmysel pre humor a pozitívny prístup ma motivuje a dodáva mi energiu do každodenného života.'
        },
        gojo: {
          description: 'gojosatoru11222 ma inšpiruje a motivuje k osobnému rastu. Je to priateľ, s ktorým môžem otvorene zdieľať svoje myšlienky a názory, a zároveň dostávam nový pohľad na situácie, ktoré ma posúvajú ďalej. Vďaka jeho podpore sa cítim silnejší a viac prepojený s okolím.'
        }
      }
    },

    contact: {
      scamWarning:
        'Ak ma chcete kontaktovať, napíšte mi ako 𝒜𝐿𝒫𝐻𝒜𝐿𝒰𝒦. Ak ma niekto pridá medzi priateľov bez správy, budem to považovať za scam a automaticky ho zablokujem.',
      heroTitle: 'Kontakt',
      heroEyebrow: 'Spojme sa',
      discordSectionTitle: 'Komunita na Discorde',
      formSectionTitle: 'Napíšte mi',
      formSectionSubtitle:
        'Vyplňte formulár — otvorí sa váš e-mailový klient so správou pripravenou na odoslanie.',
      mailtoMissingConfig:
        'Pre odoslanie e-mailu nastavte premennú REACT_APP_CONTACT_EMAIL v súbore .env (Create React App).',
      discordDescription: 'Discord zatiaľ nemáme verejne dostupný. Pripravujeme komunitný server, čoskoro bude!',
      discordSoon: '💬 Discord čoskoro',
      faqTitle: 'Často kladené otázky',
      form: {
        badge: 'Kontaktný formulár',
        nameLabel: 'Meno a priezvisko *',
        namePlaceholder: 'Ján Novák',
        emailLabel: 'E-mail *',
        emailPlaceholder: 'jan.novak@example.com',
        subjectLabel: 'Predmet *',
        subjectPlaceholder: 'Nový projekt — e‑shop',
        budgetLabel: 'Rozpočet (voliteľné)',
        budgetPlaceholder: 'Vyberte rozpočet',
        timelineLabel: 'Časový rámec (voliteľné)',
        timelinePlaceholder: 'Vyberte časový rámec',
        messageLabel: 'Správa *',
        messagePlaceholder: 'Opíšte mi váš projekt, ciele a požiadavky…',
        contactMethodLabel: 'Preferovaný spôsob kontaktu',
        submit: 'Odoslať správu',
        sending: 'Odosielanie…',
        charCount: '{{count}}/500 znakov',
        budget: {
          '': 'Vyberte rozpočet',
          'under-5k': 'Do 50 000 €',
          '5k-10k': '50 000 – 100 000 €',
          '10k-25k': '100 000 – 250 000 €',
          '25k-50k': '250 000 – 500 000 €',
          'over-50k': 'Nad 500 000 €',
          discuss: 'Chcem prediskutovať',
        },
        timeline: {
          '': 'Vyberte časový rámec',
          urgent: 'Urgentné (do 1 týždňa)',
          '1-month': 'Do 1 mesiaca',
          '2-3-months': '2–3 mesiace',
          '3-6-months': '3–6 mesiacov',
          '6-plus-months': '6+ mesiacov',
          flexible: 'Flexibilné',
        },
        method: {
          email: 'E-mail',
          phone: 'Telefón',
          video: 'Videohovor',
        },
        errors: {
          name: 'Meno je povinné',
          email: 'E-mail je povinný',
          emailInvalid: 'Neplatný formát e-mailu',
          subject: 'Predmet je povinný',
          message: 'Správa musí mať aspoň 10 znakov',
        },
      },
      faq: {
        q1: { question: 'Ako rýchlo odpovedáš na správy?', answer: 'Záleží na vyťažení, ale väčšinou odpoviem do 24 hodín. Na technické alebo projektové otázky si radšej vezmem trochu viac času, aby som odpovedal poriadne a nie len formálne. Kvalita odpovede je pre mňa dôležitejšia než rýchlosť.' },
        q2: { question: 'V akých technológiách pracuješ?', answer: 'Používam hlavne React, Node.js a TypeScript, to je kombinácia, ktorá mi umožňuje tvoriť rýchle a stabilné aplikácie. Nehoním sa za módnymi frameworkmi, skôr hľadám technológie, ktoré majú dlhodobý zmysel.' },
        q3: { question: 'Prečo si sa začal venovať programovaniu?', answer: 'Chcel som mať možnosť tvoriť veci, ktoré naozaj fungujú. Programovanie mi dalo priestor spojiť logiku s kreativitou, premýšľať, navrhovať a riešiť problémy. Je to spôsob, ako pretvoriť nápad na niečo reálne, a zároveň nikdy nekončiaci proces učenia.' },
        q4: { question: 'Čo ťa na tvojej práci baví nejvíc?', answer: 'Ten moment, keď z nápadu vznikne niečo, čo žije vlastným životom. Keď aplikácia, ktorú postavíš, začne ľuďom reálne pomáhať. Je to zmes frustrácie, trpezlivosti a radosti, ale právě v tom je kúzlo vývoja.' },
        q5: { question: 'Čo pre teba bola najväčšia profesijná výzva?', answer: 'Vytvoriť systém, ktorý nesmie zlyhať. Každá chyba mohla mať dôsledky pre skutočných ľudí, takže jsem se musel naučiť premýšľať o kóde inak, s větším rešpektom k tomu, aký dopad má moja práca. Odvtedy beriem každý projekt vážne: nie ako úlohu, ale ako zodpovednosť.' },
        q6: { question: 'Ako pristupuješ k novým projektom?', answer: 'Vždy sa pýtam prečo. Nechcem len písať kód, chcem pochopiť, aký problém sa rieši a komu to má pomoci. Keď poznám zmysel, dokážem navrhnúť riešenie, ktoré má hlavu a pätu. Snažím sa vyvážiť funkčnosť, udržateľnosť a rozumné náklady.' },
        q7: { question: 'Prečo projekty stojí peníze?', answer: 'Pretože vývoj nie je len o napísaní pár riadkov kódu. Každý projekt znamená hodiny analýzy, návrhu, testovania, ladenia a zodpovednosti. Za výsledkom nie je len samotná práca, ale aj skúsenosti, ktoré umožňujú urobiť veci správne, bezpečne, stabilne a dlhodobo. Platíš teda nielen za čas, ale hlavne za riešenie problému, které funguje a vydrží. A to má hodnotu, pretože ušetrí čas, chyby aj stres v budúcnosti.' },
        q8: { question: 'Co považuješ za najdôležitejšie v programovaní?', answer: 'Úprimnosť k sebe aj ku kódu. Ak niečo nefunguje, priznať to a nájsť riešenie. Neprekombinovať veci, keď to nie je nutné. A premýšľať nad tým, kto ten softvér používa a prečo. Kód môže byť dokonalý technicky, ale ak ľuďom nepomáha, stráca zmysel.' }
      }
    },

    projects: {
      heroTitle: 'Projekty',
      projectsContent: 'Už čoskoro tu nájdete moje najnovšie, najprepracovanějšie a najinovatívnejšie projekty, na ktorých momentálne intenzívne pracujem. 🌟 Každý z nich vzniká s dôrazom na kvalitu, originalitu a praktičnost, aby bol prínosom nielen pre mňa, ale aj pre vás, či už ste vývojár, tvůrce obsahu, alebo jednoducho niekto, kto má rád moderné technológie a nápady, ktoré dávajú zmysel. <br /><br />' +
          'Tieto projekty tu nebudú len na ukázku. Budete si ich môcť stiahnuť na voľné použitie, aby ste s nimi mohli ďalej pracovať podľa svojich predstáv. Chcem, aby každý mal možnosť využiť ich naplno, upraviť ich, rozšíriť alebo ich začleniť do vlastných projektov. Moja filozofia je jednoduchá: keď niečo tvorím, chcem, aby to mohlo pomôcť aj ostatným. 💡 <br /><br />' +
          'Každý projekt bude starostlivo opísaný, s uvedením všetkých dôležitých detailov, návodov a možností využitia. Tým vám chcem uľahčiť prácu a zabezpečiť, že presne pochopíte, ako s projektom naložiť a čo všetko z neho môžete vyťažiť. 📘 <br /><br />' +
          'A ak by ste si priali, môžem vám navyše projekt nastaviť priamo na hosting, aby ste sa nemuseli starať o žiadne technické záležitosti. Celý proces nasadenia, konfigurácie aj otestovania vykonám za vás, vy tak dostanete hotové riešenie, ktoré bude okamžite pripravené na použitie. 💻 <br /><br />' +
          '✨ Už čoskoro sa teda môžete tešiť na miesto plné nápadov, inšpirácie a technických riešení, ktoré vám otvoria nové možnosti. Pripravte sa, toto bude ešte len začiatok! 🚀',
    },
    ads: {
      heroTitle: '📰 Reklamy – už čoskoro na mojom webe!',
      heroSubtitle:
        'Pracujem na tom, aby bolo na webe jednoducho a prehľadne pridávať, upravovať a spravovať reklamy, či už ide o projekty, služby, servery alebo čokoľvek zaujímavé, čo chcete ukázať ostatným.',
      introP1:
        'Pracujem na tom, aby bolo na webe jednoducho a prehľadne pridávať, upravovať a spravovať reklamy, či už ide o projekty, služby, servery alebo čokoľvek zaujímavé, čo chcete ukázať ostatným.',
      introP2:
        'Mojím cieľom je vytvoriť systém, ktorý ponúkne nielen priestor na zviditeľnenie, ale aj pohodlné a bezpečné prostredie pre používateľov.',
      introP3:
        'Momentálne sa sústredím hlavne na backend, teda na časť webu, ktorá zabezpečuje, aby všetko správne fungovalo v zákulisí.',
      backendTitle: 'Čo je backend?',
      backendLead: 'Zjednodušene povedané, backend je mozog každého webu.',
      backendP1:
        'Zatiaľ čo frontend je to, čo vidíte – tlačidlá, texty, obrázky a stránky –, backend pracuje potichu na pozadí a stará sa o všetko medzi používateľom a serverom.',
      backendP2: 'Vďaka backendu bude možné',
      backendList: [
        { icon: '🧾', text: 'Vytvárať a ukladať vaše reklamy' },
        { icon: '🔐', text: 'Registrovať sa a prihlasovať cez vlastný účet' },
        { icon: '👤', text: 'Spravovať profil a prehľad reklám' },
        { icon: '💬', text: 'Komunikovať s ostatnými používateľmi' },
        { icon: '📊', text: 'Zobrazovať štatistiky návštevnosti a zobrazení' },
      ],
      backendP3:
        'Všetky tieto funkcie vyžadujú bezpečné prepojenie medzi webom a databázou, na čom práve pracujem.',
      backendP4:
        'Keď bude táto časť dokončená, spustím plnohodnotný systém s registráciou, prihlásením a pridávaním reklám.',
      nextTitle: 'Čo vás čaká ďalej',
      nextP1:
        'Keď bude backend plne hotový, stránka s reklamami sa otvorí všetkým registrovaným používateľom.',
      nextP2:
        'Každý bude mať účet, kde uvidí svoje reklamy, môže ich upravovať, mazať a sledovať ich úspešnosť.',
      nextP3:
        'Chcem, aby bol systém jednoduchý, rýchly a prehľadný aj pre tých, ktorí s webmi nemajú skúsenosti.',
      nextP4:
        'Cieľom je férové prostredie, kde má každý možnosť zviditeľniť projekt alebo ponuku bez zbytočných komplikácií a poplatkov.',
      whenTitle: 'Kedy to bude hotové?',
      whenP1:
        'Pracujem postupne, testujem prihlasovanie, profily aj bezpečnostné funkcie, aby všetko bežalo hladko a bez chýb.',
      whenP2: 'Nechcem nič uponáhľať, lebo kvalitný základ je dôležitejší než rýchle spustenie.',
      ctaTitle: 'Zostaňte naladení!',
      ctaText:
        'Čoskoro pridám viac informácií a spustím beta verziu. Ak máte nápady alebo otázky, kontaktujte ma cez kontaktnú stránku.',
      contactCta: 'Prejsť na kontakt',
    },
    footer: {
      socialLinksTitle: 'Sociálne siete',
      soonPagesTitle: 'Čoskoro dostupné stránky',
      adsSoon: 'Reklama (čoskoro)',
      projectsSoon: 'Projekty (čoskoro)',
      faqLink: 'FAQ',
      madeWith: 'Vytvorené s ❤️ a kódom.',
      copyright: '© {{year}} Alphaluk. Všetky práva vyhradené.'
    },
    about: {
      heroTitle: 'Môj Príbeh',
      heroSubtitle: 'Príbeh človeka, ktorý napriek bolesti tvorí, baví a inšpiruje.',
      bookSectionTitle: 'Objavte svet Tourettovho syndrómu',
      bookSectionSubtitle: 'Odporúčanie na knihu, ktorá otvára dvere k pochopeniu',
      bookBadge: 'Odporúčaná literatúra',
      bookTitle: 'Žijeme s Tourettovým syndromem',
      bookLead: 'Ak chcete vedieť viac o Tourettovom syndróme, môžete si prečítať knihu <strong>Žijeme s Tourettovým syndromem</strong>.',
      bookDescription: 'Nejde o žiadnu platenú propagáciu, jednoducho si myslím, že je to veľmi užitočný zdroj pre všetkých, ktorí chcú pochopiť, čo Tourettov syndróm obnáša, ako sa s ním žije a ako môžu ľuďom s týmto syndrómom pomôcť alebo ich lepšie pochopiť.',
      cardTitle: 'Kniha plná',
      cardSubtitle: 'poznania & pochopenia',
      buttonText: 'Zobraziť knihu',
      personalNoteTitle: 'Osobná Poznámka',
      personalNoteP1: 'Netvorím preto, že musím. Robím to, pretože ma to drží nad vodou a dáva mi pocit slobody. Videá, projekty, humor… to všetko je spôsob, ako hovorím o tom, čo žijem, a ako sa snažím druhým priniesť trochu svetla aj v dňoch, keď ho sami moc nevidia.',
      personalNoteP2: 'Moje zdravotné problémy sú jednoducho súčasťou môjho života. Každý deň si rozvrhnem tak, aby som mal silu pokračovať. Niekedy to ide lepšie, niekedy horšie. Nevzdávam sa, len sa učím byť k sebe férový a rešpektovať, čo moje telo zvládne.',
      personalNoteP3: 'Môj cieľ je jednoduchý: byť úprimný, baviť a hlavne inšpirovať. Každý človek, ktorý niečo zvláda potichu a bez pochopenia ostatných, je pre mňa hrdina svojho vlastného príbehu. A ak môžem aspoň jednému človeku pripomenúť, že svetlo existuje aj vo chvíľach, keď to vyzerá, že tma víťazí, splnil som svoj účel.',
      storyContent: `Volám sa AlphaLuk. Pre väčšinu ľudí som len meno z internetu. Nejaká tvorba, videá, projekty. Ale za tým všetkým je život, ktorý nebol ľahký, a skúsenosti, ktoré ma formovali viac, než si dokážem priznať.\n\n**Moje problémy začali, keď som mal osem rokov.** Tiky, závraty, zvláštne stavy, z ktorých som sa bál. Nikto to nechápal. Spolužiaci sa mi smiali, učitelia mi neverili a dokonca aj riaditeľka ma nechala napospas. Nešlo len o dospelých, aj deti ma šikanovali, posmievali sa mi, odsudzovali ma za niečo, čo nemôžem ovládať.

**Pamätám si jeden okamih v telesnej výchove.** Zatočila sa mi hlava tak, že som nevedel, či spadnem, alebo čo sa so mnou deje. Rozplakal som sa. A namiesto pomoci prišlo len:
"Prestaň si vymýšľať a pokračuj."\n\n**Ten pocit bezmoci je niečo, čo sa ti vryje do pamäti navždy.** Malý chlapec, ktorý nechápe, prečo mu nikto neverí, prečo svet, ktorý by mal chrániť, je proti nemu. Nakoniec to vyústilo v prestup uprostred piatej triedy. Nová škola bola iná. Tam som narazil na dve učiteľky, ktoré mi verili a podporovali ma. Práve ony mi vtedy dodali silu ísť ďalej.\n\n**Moje zdravotné problémy pokračovali.** Lekári mi neskôr povedali, že najskôr mám miernu formu epilepsie, ale potvrdené to nie je. A aj tak je každý deň výzvou. Niekedy je deň v pohode, niekedy mám pocit, že sa svet točí a ja len bojujem o rovnováhu. Von moc nechodím sám, nikdy neviem, čo príde.\n\n**Tvorba bola vždy môj únik. Žijem s diagnózou, ktorá ovplyvňuje môj každodenný život.** Niekedy sa mi motá hlava, niekedy mám dni, kedy proste nemôžem. Von moc nechodím sám, pretože nikdy neviem, čo sa môže stať. Ale aj napriek tomu sa snažím robiť to, čo milujem, tvoriť. Tvorba je pre mňa úľava. Keď strihám videá, keď pracujem na projektoch, cítim sa slobodný. Som súčasťou EchoDabing, kde pomáham s videami a propagačnými materiálmi. Mám svoj Minecraft survival server, ktorý ešte vyvíjam, a tiež robím na React projektoch, ktoré ma veľmi bavia. Baví ma posúvať veci ďalej, skúšať nové nápady, tvoriť vlastné cesty.\n\n**Nie som obyčajný človek, ktorý sa len vezie životom.** Musel som si vybudovat sílu sám. Moji rodičia sú pre mňa obrovskou oporou, stojí za mnou aj v chvíľach, keď už sám neviem, či mám silu pokračovať. Mám tiež jedného skvelého kamaráta, ktorý ma nikdy neopustil, a svoju psychologičku, ktorá mi pomáha chápať veci, ktoré ma dlho ničili zvnútra. Ale aj tak je tá podpora niekedy slabá, pretože väčšinu mojich bojov musím vybojovať ja sám.\n\n**Nikdy nezabudnem na to, ako sa ľudia dokážu posmievať niečemu, čomu nerozumejú.** Keď máš problém, ktorý nie je vidieť, ľudia ťa často odsúdia. A práve to ma naučilo byť silnejším. Naučilo ma to chápať ostatných. Viem, aké to je byť sám. Viem, aké to je, keď ťa nikto nechápe. A preto chcem, aby môj príbeh pomohol ostatným. Chcem, aby ľudia vedeli, že aj keď svet nie je fér, nikdy nesmieš prestať veriť. Niekedy to bolí, niekedy to trvá roky, ale cesta existuje. A aj keď máš diagnózu, tiky, závraty alebo iné problémy, nie si slabý. Naopak. Si silný, pretože vstávaš každé ráno a bojuješ.\n\n**Mojím cieľom je byť inšpiráciou.** Nie preto, že chcem slávu. Ale pretože chcem ukázať, že aj človek, ktorého život zhodil na dno, môže zdvihnúť hlavu a ísť ďalej. Chcem, aby moje videá a projekty mali zmysel, aby v nich ľudia našli kúsok nádeje, odvahy alebo aspoň úsmev. Dnes už viem, že minulosť nezmením. Ale môžem z nej čerpať silu. Všetko, čo som prežil, bolesti, nepochopenie, pády, ma posilnilo. A aj keď mám stále dni, keď je to ťažké, už sa nebojím. Pretože viem, kto som. Som AlphaLuk. Som človek, ktorý sa nevzdal. A nikdy sa nevzdám.\n\n**A ak toto číta niekto, kto prechádza niečím podobným:**\n\nNie si slabý. Nie si divný. Nie si sám.\n\nNiekedy sa ti budú smiať, niekedy ti neveria, niekedy ťa odsudia. Ale to neznamená, že tvoj boj nie je skutočný, že tvoja bolesť je menej hodnotná.\n\n**Ja som AlphaLuk.**

Prešiel som si vecami, ktoré ma lámaly (od šikany detí, učiteľov aj riaditeľky) a napriek tomu stojím. Neprestal som bojovať. A nikdy neprestanem.

**Ak to dokázal niekto ako ja, dokážeš to aj ty.**`
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'cs',
    defaultNS: 'common',
    interpolation: { escapeValue: false }
  });

export default i18n;